import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LoadingSkeletonComponent } from '@shared/components/loading-skeleton';
import { LoadingSkeletonBaseClass } from '@shared/components/loading-skeleton-base-class';

@Component({
  selector: 'app-chargers-overview-movable-panel-loading-skeleton',
  imports: [LoadingSkeletonComponent],
  templateUrl: './chargers-overview-movable-panel-loading-skeleton.component.html',
  host: { class: 'flex flex-col relative' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChargersOverviewMovablePanelLoadingSkeletonComponent extends LoadingSkeletonBaseClass {}
